import React from "react";
import _ from "lodash";
import Color from "color";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

import IconLink from "@material-ui/icons/Link";
import IconVisibility from "@material-ui/icons/Visibility";
import IconVisibilityOff from "@material-ui/icons/VisibilityOff";
import CancelIcon from "@material-ui/icons/Cancel";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import numeral from "numeral";

import ButtonAddToCompare from "../ButtonAddToCompare";
import { P } from "../Typography";

import { getProjectStat, getRoomDataForRender } from "../../utils/stat-utils";
import { getColorByYearComplete } from "../../screens/MapScreen/utils";

const Container = styled.div`
  min-width: 240px;

  .marker-body {
    display: flex;
    flex-direction: row;

    .marker-body-left {
      flex: 1;
    }

    .marker-body-right: {
      flex: 0 0 40px;
    }
  }
`;

const Detail = styled(P)`
  margin: 0px !important;
  margin-right: 20px !important;
  white-space: nowrap;
`;

const ViewToggleButton = (props) => (
  <IconButton {..._.omit(props, ["active"])}>
    {props.active ? (
      <IconVisibility fontSize="small" />
    ) : (
      <IconVisibilityOff fontSize="small" style={{ color: "" }} />
    )}
  </IconButton>
);

const HideToggleButton = (props) => (
  <IconButton {..._.omit(props, ["active"])}>
    {props.active ? (
      <CancelIcon fontSize="small" />
    ) : (
      <HighlightOffIcon fontSize="small" style={{ color: "" }} />
    )}
  </IconButton>
);

const LinkButton = (props) => (
  <IconButton {...props}>
    <IconLink fontSize="small" style={{ transform: `rotate(45deg)` }} />
  </IconButton>
);

const ProjectNotShowDetail = styled.div`
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.6rem;
  margin: 5px;
`;

const ActionBarPopover = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40px;
  position: absolute;
  top: 50%;
  right: -45px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
`;

const ActionBarProjectShowDetail = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding-bottom: 4px;
  border-left: 1px solid
    ${(props) => Color(props.color).darken(0.2).string() || "black"};
`;

const HeaderActionBarProjectShowDetail = styled.div`
  display: flex;
  flex-direction: column-reverse;
  border-bottom: 1px solid
    ${(props) => Color(props.color).darken(0.2).string() || "black"};
  padding: 8px 0px;
  margin-bottom: 8px;
`;

const detailLabels = {
  developer: { label: "Developer", prefix: "" },
  yearLaunch: { label: "Year Open", prefix: "", format: "0" },
  yearComplete: { label: "Year Complete", prefix: "", format: "0" },
  station: { label: "Station", prefix: "" },
  distanceFromBts: { label: "Distance to BTS", prefix: "", format: "0.00a" },
  totalUnits: { label: "Total Units", prefix: "", format: "0" },
  parkingLot: { label: "Parking Lot", prefix: "", suffix: "%" },
  projectType: { label: "Project Type", prefix: "" },
  floor: { label: "Floor", prefix: "", format: "0" },
  furniturePackage: { label: "Furniture Package", prefix: "" },
  ceiling: { label: "Ceiling", prefix: "", format: "0.00a" },
  sinkingFund: { label: "Sinking Fund", prefix: "", format: "0" },
  commonFee: { label: "Common Fee", prefix: "", format: "0" },

  percentSold: { label: "% Sold", prefix: "", format: "0.00", suffix: "%" },
  unitsLeft: { label: "Units Left", prefix: "", format: "0" },
  projectStatus: { label: "Project Status", prefix: "" },
  constructionStatus: { label: "Construction Status", prefix: "" },
  absorptionRateAll: {
    label: "Absorption Rate / Quarter",
    prefix: "",
    format: "0.00a",
    suffix: "%",
  },
  absorptionRateLastQ: {
    label: "Absorption Rate Last Quarter",
    prefix: "",
    format: "0.00a",
    suffix: "%",
  },

  startingResalePrice: {
    label: "Avg. Resale Package (For Sale)",
    prefix: "",
    format: "0.00a",
  },
  resalePriceSqm: {
    label: "Avg. Resale Price /sq.m. (For Sale)",
    prefix: "",
    format: "0.00a",
  },
  rentalPrice: {
    label: "Avg. Rental Package (For Rent)",
    prefix: "",
    format: "0.00a",
  },
  rentalPriceSqm: {
    label: "Avg. Rental Price /sq.m. (For Rent)",
    prefix: "",
    format: "0.00a",
  },
  capitalGain: { label: "Cap. Gain", prefix: "", format: "0.00a" },
  rentalYield: {
    label: "Rental Yield",
    prefix: "",
    format: "0.00",
    suffix: "%",
  },

  launchPriceSqm: {
    label: "Average of Launch Price",
    prefix: "",
    format: "0.00a",
  },
  startingPrice: {
    label: "Starting Package (Project)",
    prefix: "",
    format: "0.00a",
  },
  startingCurrentPrice: {
    label: "Starting Current Package (Project)",
    prefix: "",
    format: "0.00a",
    suffix: "m",
  },
  currentPriceSqm: {
    label: "Current Price / sq.m.",
    prefix: "",
    format: "0.00a",
  },

  // percentSold: { label: '%Sold', prefix: '', suffix: '%' },
  // unitsLeft: { label: 'Units Left', prefix: '', format: '0' },
  // absorptionRateAll: {
  //   label: 'Absorption Rate (All)',
  //   prefix: '',
  //   format: '0.00%',
  // },
  // absorptionRateLastQ: {
  //   label: 'Absorption Rate (Last Q)',
  //   prefix: '',
  //   format: '0.00%',
  // },
  // launchPriceSqm: { label: 'Launch Price', prefix: '', format: '0,0.00' },
  // currentPriceSqm: { label: 'Current Price', prefix: '', format: '0,0.00' },
  // startingPrice: {
  //   label: 'Starting Price (Project)',
  //   prefix: '',
  //   format: '0,0.00',
  // },
  // currentPriceSqm: {
  //   label: 'Starting Price /sq.m. (Project)',
  //   prefix: '',
  //   format: '0,0.00',
  // },
  // sinkingFund: { label: 'Sinking Fund', prefix: '', format: '0,0.00' },
  // commonFee: { label: 'Common Fee', prefix: '', format: '0,0.00' },
  // resalePriceSqm: { label: 'Resale Price /sq.m.', prefix: '', format: '0,0.00' },
  // rentalPriceSqm: { label: 'Rental Price /sq.m.', prefix: '', format: '0,0.00' },
  // capitalGain: { label: 'Capital Gain', prefix: '', format: '0.00%' },
  // rentalYield: { label: 'Rental Yield', prefix: '', suffix: '%' },
  // startingResalePrice: {
  //   label: 'Starting Price (Resale)',
  //   prefix: '',
  //   format: '0,0.00',
  // },
  // startingResalePriceSqm: {
  //   label: 'Starting Price /sq.m. (Resale)',
  //   prefix: '',
  //   format: '0,0.00',
  // },
  // avgRoomSize: { label: 'Avg. Room Size', prefix: '', format: '0' },
  // totalUnits: { label: 'Total Units', prefix: '', format: '0' },
  // parkingLot: { label: 'Parking Lot', prefix: '', format: '0' },
};

export default class extends React.PureComponent {
  static defaultProps = {
    onValueProject: () => null,
  };

  render() {
    const {
      viewOptionList,
      checked,
      project,
      compareProjectIds,
      showDetail,
      isHover,
      pinChecked,
    } = this.props;

    let projectStat = getProjectStat(project);
    // console.log('projectStat&&', projectStat);
    // console.log('detailLabels&&', detailLabels);
    const avgRoomData = getRoomDataForRender(_.get(project, "rooms"), [
      { key: "startingPrice", mode: "min" },
      { key: "startingResalePrice", mode: "min" },
      { key: "resalePriceSqm", mode: "avg" },
      { key: "rentalPriceSqm", mode: "avg" },
      { key: "totalUnits", mode: "sum" },
      { key: "soldUnits", mode: "sum" },
      { key: "unitsLeft", mode: "sum" },
      { key: "percentSold", mode: "avg" },
      { key: "rentalYield", mode: "avg" },
      { key: "capitalGain", mode: "avg" },
    ]);
    // console.log("avgRoomData??", avgRoomData);
    _.map(avgRoomData, (a, i) => {
      if (i !== "count") {
        projectStat = {
          ...projectStat,
          [i]: a,
        };
      }
    });

    const linkToAgent = _.get(project, "integrations.TheAgent.ProjectLink");
    const theAgentProjectId = _.get(project, "integrations.TheAgent.ProjectID");
    const projectAdddedToCompare = _.some(
      compareProjectIds,
      (proId) => proId === _.get(project, "id")
    );
    const getStatTxt = (item, value) => {
      if (
        value === "N/A" ||
        _.toNumber(value) === 0 ||
        _.isNil(value) ||
        _.isUndefined(value)
      ) {
        return "N/A";
      } else if (_.isNaN(value)) {
        return value;
      } else {
        const mainTxt = _.get(detailLabels, `${item}.format`)
          ? numeral(value).format(_.get(detailLabels, `${item}.format`))
          : value;
        return `${_.get(detailLabels, `${item}.prefix`) || ""}${mainTxt}${
          _.get(detailLabels, `${item}.suffix`) || ""
        }`;
      }
    };
    if (showDetail) {
      return (
        <Container>
          <HeaderActionBarProjectShowDetail
            color={getColorByYearComplete(_.get(project, "yearComplete"))}
          >
            <P style={{ fontWeight: "bold", margin: 0 }}>{project.title.en}</P>
          </HeaderActionBarProjectShowDetail>
          <div className="marker-body">
            <div className="marker-body-left">
              <table>
                <tbody>
                  {viewOptionList.map((item) => (
                    <tr key={item}>
                      <td>
                        <Detail>{detailLabels[item].label}</Detail>
                      </td>
                      <td>
                        <Detail>
                          {getStatTxt(item, _.get(projectStat, item))}
                        </Detail>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="marker-body-right">
              <ActionBarProjectShowDetail
                color={getColorByYearComplete(_.get(project, "yearComplete"))}
              >
                {!_.isEmpty(linkToAgent) && !_.isEmpty(theAgentProjectId) && (
                  <Tooltip placement="top" title="Link to sTheAgent">
                    <LinkButton
                      component="a"
                      target="_blank"
                      href={linkToAgent}
                    />
                  </Tooltip>
                )}
                <Tooltip
                  placement="top"
                  title={checked ? "Hide on Map" : "Show on Map"}
                >
                  <ViewToggleButton
                    active={!checked}
                    onClick={() => {
                      console.log("hide on map");
                      this.props.onValueProject("theEye", _.get(project, "id"));
                    }}
                  />
                </Tooltip>
                <Tooltip
                  placement="top"
                  title={
                    !projectAdddedToCompare
                      ? "Add to Compare"
                      : "Remove from Compare"
                  }
                >
                  <ButtonAddToCompare
                    onClick={() =>
                      this.props.onValueProject("compare", _.get(project, "id"))
                    }
                    active={projectAdddedToCompare}
                  />
                </Tooltip>
                <Tooltip placement="top" title={"Hide pin"}>
                  <HideToggleButton
                    onClick={() =>
                      this.props.onValueProject("pin", _.get(project, "id"))
                    }
                  />
                </Tooltip>
              </ActionBarProjectShowDetail>
            </div>
          </div>
        </Container>
      );
    }

    if (isHover) {
      return (
        <ProjectNotShowDetail>
          <P style={{ margin: 0 }}>{project.title.en}</P>
          {/* <ActionBarPopover>
            {!_.isEmpty(linkToAgent) && (
              <Tooltip placement="bottom" title="Link to TheAgent">
                <LinkButton component={Link} target="_blank" to={linkToAgent} />
              </Tooltip>
            )}
            <Tooltip
              placement="bottom"
              title={
                !projectAdddedToCompare
                  ? "Add to Compare"
                  : "Remove from Compare"
              }
            >
              <ButtonAddToCompare
                onClick={() =>
                  this.props.onValueProject("compare", _.get(project, "id"))
                }
                active={projectAdddedToCompare}
              />
            </Tooltip>
          </ActionBarPopover> */}
        </ProjectNotShowDetail>
      );
    }

    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkToolTip/index.js